<div [class]="`boxPlan__cableTubeGroup boxPlan__cableTubeGroup__${cable().code} boxPlan__cableTubeGroup__${side()}`">
    <div [class]="`boxPlan__cables boxPlan__cables__${side()}`">
        <div [class]="`boxPlan__cable boxPlan__cable__${cable().code} boxPlan__cable__${side()}`">
            <div class="flex flex-col justify-between relative h-full">
                <div>
                    <div class="flex flex-row justify-between gap-4">
                        <mat-checkbox
                            color="primary"
                            [checked]="synopticPlanEditService.selectedCables().has(cable().code)"
                            (change)="toggleCableSelection()" />
                        <fa-icon
                            class="cursor-pointer text-custom-dark-grey hover:text-error"
                            size="sm"
                            [icon]="['fas', 'xmark']"
                            (click)="remove.emit()" />
                    </div>
                    <p>
                        {{ 'synopticPlan.cable' | transloco }}
                        <span class="font-semibold">{{ cable().label }}</span>
                    </p>
                    @if (isCableOpen()) {
                        <p class="pb-2">
                            {{ 'synopticPlan.code' | transloco }}
                            <span class="font-semibold">{{ cable().code }}</span>
                        </p>
                        <p>
                            {{ 'synopticPlan.externalCode' | transloco }}
                            <span class="font-semibold">{{ cable().externalCode }}</span>
                        </p>
                        <p class="pt-2">
                            {{
                                (side() === CableDirectionEnum.RIGHT
                                    ? 'synopticPlan.downstreamBoxBay'
                                    : 'synopticPlan.upstreamBoxBay'
                                ) | transloco: { TYPE: cable().boxCode ? 'box' : 'bay' }
                            }}
                            <span class="font-semibold">
                                {{ cable().bayCode ? cable().bayLabel : cable().boxLabel }}
                            </span>
                        </p>
                        <p>
                            {{ 'synopticPlan.code' | transloco }}
                            <span class="font-semibold">{{ cable().boxCode || cable().bayCode }}</span>
                        </p>
                        <p>
                            {{ 'synopticPlan.externalCode' | transloco }}
                            <span class="font-semibold">{{
                                cable().bayCode ? cable().bayExternalCode : cable().boxExternalCode
                            }}</span>
                        </p>
                    }
                </div>
                <div class="flex justify-end gap-x-2">
                    <fa-icon
                        size="lg"
                        [class]="
                            isLast() ? 'cursor-not-allowed text-custom-dark-grey' : 'cursor-pointer text-custom-blue'
                        "
                        [icon]="['fas', 'arrow-down']"
                        (click)="
                            isLast()
                                ? $event.stopPropagation()
                                : cableOrderChange.emit({ code: cable().code, action: CableActionEnum.DOWN })
                        " />
                    <fa-icon
                        size="lg"
                        [class]="
                            index() ? 'cursor-pointer text-custom-blue' : 'cursor-not-allowed text-custom-dark-grey'
                        "
                        [icon]="['fas', 'arrow-up']"
                        (click)="
                            index()
                                ? cableOrderChange.emit({ code: cable().code, action: CableActionEnum.UP })
                                : $event.stopPropagation()
                        " />
                </div>
            </div>
        </div>
    </div>
    <div [class]="`boxPlan__tubes boxPlan__tubes__${side()} gap-y-5`">
        @for (tube of tubes() | keyvalue; track tube.key) {
            <app-side-tube-edit
                [areAllFibersAssigned]="areAllFibersAssigned(tube.key)"
                [cableCode]="cable().code"
                [cassettes]="cassettes()"
                [fibers]="tube.value"
                [isOpen]="isTubeLinkedToOpenedCassette(tube.key)"
                [planType]="planType()"
                [side]="side()"
                [tubeNumber]="tube.key"
                (toggle)="toggleTube.emit()" />
        }
    </div>
</div>
